export enum AuthorizationErrorCode {
    CANNOT_ACCESS_ORGANIZATION_WAITING_TIMES = 'CANNOT_ACCESS_ORGANIZATION_WAITING_TIMES',
    CANNOT_ACCESS_REQUESTS_CLOSED_BY_OTHER_REQUESTER_ORGANIZATIONS = 'CANNOT_ACCESS_REQUESTS_CLOSED_BY_OTHER_REQUESTER_ORGANIZATIONS',
    CANNOT_ADD_ADDENDUM = 'CANNOT_ADD_ADDENDUM',
    CANNOT_ADD_CONSULT_DIAGNOSTIC_REPORT = 'CANNOT_ADD_CONSULT_DIAGNOSTIC_REPORT',
    CANNOT_ADD_DIAGNOSTIC_REPORT_CLARIFICATION_PERFORMER = 'CANNOT_ADD_DIAGNOSTIC_REPORT_CLARIFICATION_PERFORMER',
    CANNOT_ADD_DIAGNOSTIC_REPORT_CLARIFICATION_REQUESTER = 'CANNOT_ADD_DIAGNOSTIC_REPORT_CLARIFICATION_REQUESTER',
    CANNOT_ADD_DISCHARGE_DIAGNOSTIC_REPORT = 'CANNOT_ADD_DISCHARGE_DIAGNOSTIC_REPORT',
    CANNOT_ADD_EXAMINATION_DIAGNOSTIC_REPORT = 'CANNOT_ADD_EXAMINATION_DIAGNOSTIC_REPORT',
    CANNOT_ADD_INTAKE_DIAGNOSTIC_REPORT = 'CANNOT_ADD_INTAKE_DIAGNOSTIC_REPORT',
    CANNOT_ADD_PROCEDURE = 'CANNOT_ADD_PROCEDURE',
    CANNOT_ASSIGN_DEVICE_ALREADY_IN_USE = 'CANNOT_ASSIGN_DEVICE_ALREADY_IN_USE',
    CANNOT_ASSIGN_TO_COLLEAGUE = 'CANNOT_ASSIGN_TO_COLLEAGUE',
    CANNOT_BECOME_REQUESTER = 'CANNOT_BECOME_REQUESTER',
    CANNOT_CHANGE_SERVICE_TO_SERVICE = 'CANNOT_CHANGE_SERVICE_TO_SERVICE',
    CANNOT_CHANGE_STATE = 'CANNOT_CHANGE_STATE',
    CANNOT_CLOSE_INCOMPLETED_WATCHPAT_OSASO = 'CANNOT_CLOSE_INCOMPLETED_WATCHPAT_OSASO',
    CANNOT_COMPLETE_PATIENT_TASK = 'CANNOT_COMPLETE_PATIENT_TASK',
    CANNOT_COMPLETE_PROCEDURE = 'CANNOT_COMPLETE_PROCEDURE',
    CANNOT_CREATE_BANK_ACCOUNT_DETAILS_LOG = 'CANNOT_CREATE_BANK_ACCOUNT_DETAILS_LOG',
    CANNOT_CREATE_COMPENSATION_PAYOUT = 'CANNOT_CREATE_COMPENSATION_PAYOUT',
    CANNOT_CREATE_CONTRACT_SETTING = 'CANNOT_CREATE_CONTRACT_SETTING',
    CANNOT_CREATE_EMPLOYMENT_TAXES_DETAILS = 'CANNOT_CREATE_EMPLOYMENT_TAXES_DETAILS',
    CANNOT_CREATE_EMPLOYMENT_TAXES_DETAILS_EXPORT = 'CANNOT_CREATE_EMPLOYMENT_TAXES_DETAILS_EXPORT',
    CANNOT_CREATE_PAYABLE_SERVICE_ACTIVITY = 'CANNOT_CREATE_PAYABLE_SERVICE_ACTIVITY',
    CANNOT_CREATE_PROCEDURE = 'CANNOT_CREATE_PROCEDURE',
    CANNOT_CREATE_REQUEST = 'CANNOT_CREATE_REQUEST',
    CANNOT_DELETE_ACCOUNT_REQUEST = 'CANNOT_DELETE_ACCOUNT_REQUEST',
    CANNOT_DELETE_AVAILABILITY = 'CANNOT_DELETE_AVAILABILITY',
    CANNOT_DELETE_EMPLOYMENT_ASSETS = 'CANNOT_DELETE_EMPLOYMENT_ASSETS',
    CANNOT_DELETE_OTP_METHOD = 'CANNOT_DELETE_OTP_METHOD',
    CANNOT_DELETE_PATIENT_INVOICE_SERVICE_PRICE = 'CANNOT_DELETE_PATIENT_INVOICE_SERVICE_PRICE',
    CANNOT_DELETE_SERVICE_ACTIVITY_PERFORMER = 'CANNOT_DELETE_SERVICE_ACTIVITY_PERFORMER',
    CANNOT_DELETE_SERVICE_EMPLOYMENT = 'CANNOT_DELETE_SERVICE_EMPLOYMENT',
    CANNOT_GET_ACCESS_TO_COUNSELING = 'CANNOT_GET_ACCES_TO_COUNSELING',
    CANNOT_IMPORT_BANK_ACCOUNT_DETAILS = 'CANNOT_IMPORT_BANK_ACCOUNT_DETAILS',
    CANNOT_INSERT_ABSENCE = 'CANNOT_INSERT_ABSENCE',
    CANNOT_INSERT_ACCOUNT_REQUEST = 'CANNOT_INSERT_ACCOUNT_REQUEST',
    CANNOT_INSERT_BANK_ACCOUNT_DETAILS_CHANGE = 'CANNOT_INSERT_BANK_ACCOUNT_DETAILS_CHANGE',
    CANNOT_INSERT_DRAFT_DIAGNOSTIC_REPORT = 'CANNOT_INSERT_DRAFT_DIAGNOSTIC_REPORT',
    CANNOT_INSERT_DRAFT_PROCEDURE = 'CANNOT_INSERT_DRAFT_PROCEDURE',
    CANNOT_INSERT_DRAFT_REQUEST = 'CANNOT_INSERT_DRAFT_REQUEST',
    CANNOT_INSERT_EMPLOYMENT_CAREPATH = 'CANNOT_INSERT_EMPLOYMENT_CAREPATH',
    CANNOT_INSERT_FUNDING_SETTING_LOG = 'CANNOT_INSERT_FUNDING_SETTING_LOG',
    CANNOT_INSERT_INVALID_PROPERTIES = 'CANNOT_INSERT_INVALID_PROPERTIES',
    CANNOT_INSERT_KSYOS_EMPLOYMENT = 'CANNOT_INSERT_KSYOS_EMPLOYMENT',
    CANNOT_INSERT_ORGANIZATION_CAREPATH = 'CANNOT_INSERT_ORGANIZATION_CAREPATH',
    CANNOT_INSERT_ORGANIZATION_EMPLOYMENT = 'CANNOT_INSERT_ORGANIZATION_EMPLOYMENT',
    CANNOT_INSERT_ORGANIZATION_HISTORY = 'CANNOT_INSERT_ORGANIZATION_HISTORY',
    CANNOT_INSERT_ORGANIZATION_PRACTITIONER = 'CANNOT_INSERT_ORGANIZATION_PRACTITIONER',
    CANNOT_INSERT_OTP_METHOD = 'CANNOT_INSERT_OTP_METHOD',
    CANNOT_INSERT_PRACTITIONER_EMPLOYMENT = 'CANNOT_INSERT_PRACTITIONER_EMPLOYMENT',
    CANNOT_INSERT_PROCEDURE_DIAGNOSTIC_REPORT = 'CANNOT_INSERT_PROCEDURE_DIAGNOSTIC_REPORT',
    CANNOT_INSERT_PROCEDURE_REQUEST = 'CANNOT_INSERT_PROCEDURE_REQUEST',
    CANNOT_INSERT_SEND_DIAGNOSTIC_REPORT = 'CANNOT_INSERT_SEND_DIAGNOSTIC_REPORT',
    CANNOT_INSERT_SEND_PROCEDURE = 'CANNOT_INSERT_SEND_PROCEDURE',
    CANNOT_INSERT_SEND_REQUEST = 'CANNOT_INSERT_SEND_REQUEST',
    CANNOT_INSERT_SERVICE_ACTIVITY_PERFORMER = 'CANNOT_INSERT_SERVICE_ACTIVITY_PERFORMER',
    CANNOT_INSERT_VIEW_MEDICAL_DOSSIER_PATIENT_CONSENT = 'CANNOT_INSERT_VIEW_MEDICAL_DOSSIER_PATIENT_CONSENT',
    CANNOT_MANUAL_IMPORT_FUNDUS_SCREENING = 'CANNOT_MANUAL_IMPORT_FUNDUS_SCREENING',
    CANNOT_READ_BANK_ACCOUNT_DETAILS = 'CANNOT_READ_BANK_ACCOUNT_DETAILS',
    CANNOT_READ_BANK_ACCOUNT_DETAILS_CHANGE = 'CANNOT_READ_BANK_ACCOUNT_DETAILS_CHANGE',
    CANNOT_READ_COMPENSATION_PAYOUT = 'CANNOT_READ_COMPENSATION_PAYOUT',
    CANNOT_READ_COMPOSITE_PATIENT_INVOICES = 'CANNOT_READ_COMPOSITE_PATIENT_INVOICES',
    CANNOT_READ_DECLARATIONS = 'CANNOT_READ_DECLARATIONS',
    CANNOT_READ_DISTINCT_VALUES = 'CANNOT_READ_DISTINCT_VALUES',
    CANNOT_READ_EMPLOYMENT_ASSETS = 'CANNOT_READ_EMPLOYMENT_ASSETS',
    CANNOT_READ_EMPLOYMENT_OF_REQUEST_MESSAGE = 'CANNOT_READ_EMPLOYMENT_OF_REQUEST_MESSAGE',
    CANNOT_READ_FUNDING_EXCLUSION = 'CANNOT_READ_FUNDING_EXCLUSION',
    CANNOT_READ_FUNDING_PROCESSES = 'CANNOT_READ_FUNDING_PROCESSES',
    CANNOT_READ_GROUP_MEETINGS = 'CANNOT_READ_GROUP_MEETINGS',
    CANNOT_READ_GROUP_SESSIONS = 'CANNOT_READ_GROUP_SESSIONS',
    CANNOT_READ_MANAGER_ROLES = 'CANNOT_READ_MANAGER_ROLES',
    CANNOT_READ_MDOS = 'CANNOT_READ_MDOS',
    CANNOT_READ_ORGANIZATION_ADDABLE_SERVICE_GROUPS = 'CANNOT_READ_ORGANIZATION_ADDABLE_SERVICE_GROUPS',
    CANNOT_READ_ORGANIZATION_KSYOS_ACCOUNT = 'CANNOT_READ_ORGANIZATION_KSYOS_ACCOUNT',
    CANNOT_READ_ORGANIZATION_PATIENT_COUNT = 'CANNOT_READ_ORGANIZATION_PATIENT_COUNT',
    CANNOT_READ_ORGANIZATION_WAITING_TIMES = 'CANNOT_READ_ORGANIZATION_WAITING_TIMES',
    CANNOT_READ_OTP_METHOD = 'CANNOT_READ_OTP_METHOD',
    CANNOT_READ_PAYOUT_RECORDS = 'CANNOT_READ_PAYOUT_RECORDS',
    CANNOT_READ_REQUEST = 'CANNOT_READ_REQUEST',
    CANNOT_READ_SERVICE_CONSUMER_ORGANIZATIONS = 'CANNOT_READ_SERVICE_CONSUMER_ORGANIZATIONS',
    CANNOT_READ_SERVICE_ORGANIZATION_SETTING = 'CANNOT_READ_SERVICE_ORGANIZATION_SETTING',
    CANNOT_READ_SERVICE_SHOULD_SHOW_COST_INFO = 'CANNOT_READ_SERVICE_SHOULD_SHOW_COST_INFO',
    CANNOT_READ_SINGULAR_PATIENT_INVOICE_RECORDS = 'CANNOT_READ_SINGULAR_PATIENT_INVOICE_RECORDS',
    CANNOT_READ_TOKEN_CREATION_TIME = 'CANNOT_READ_TOKEN_CREATION_TIME',
    CANNOT_REMOVE_ABSENCE = 'CANNOT_REMOVE_ABSENCE',
    CANNOT_REPLICATE_REQUEST = 'CANNOT_REPLICATE_REQUEST',
    CANNOT_RESEND_EMAIL = 'CANNOT_RESEND_EMAIL',
    CANNOT_RESEND_INVITATIONS = 'CANNOT_RESEND_INVITATIONS',
    CANNOT_RESEND_THIRD_PARTY_MESSAGES = 'CANNOT_RESEND_THIRD_PARTY_MESSAGES',
    CANNOT_REVIEW_ACCOUNT_REQUEST = 'CANNOT_REVIEW_ACCOUNT_REQUEST',
    CANNOT_SEND_ANALYSIS = 'CANNOT_SEND_ANALYSIS',
    CANNOT_SEND_MFA_RESET_EMAIL = 'CANNOT_SEND_MFA_RESET_EMAIL',
    CANNOT_SEND_PRACTITIONER_ACTIVATION_EMAIL = 'CANNOT_UPDATE_PRACTITIONER_ACTIVATION_EMAIL',
    CANNOT_SEND_PRACTITIONER_SET_HARDWARE_TOKEN_EMAIL = 'CANNOT_SEND_PRACTITIONER_SET_HARDWARE_TOKEN_EMAIL',
    CANNOT_SEND_REQUEST_MESSAGE = 'CANNOT_SEND_REQUEST_MESSAGE',
    CANNOT_SEND_ZORGMAIL = 'CANNOT_SEND_ZORGMAIL',
    CANNOT_TAKE_ANALYSIS = 'CANNOT_TAKE_ANALYSIS',
    CANNOT_TAKE_ANALYSIS_FROM_COLLEAGUE = 'CANNOT_TAKE_ANALYSIS_FROM_COLLEAGUE',
    CANNOT_TAKE_PROCESS = 'CANNOT_TAKE_PROCESS',
    CANNOT_TAKE_PROCESS_FROM_COLLEAGUE = 'CANNOT_TAKE_PROCESS_FROM_COLLEAGUE',
    CANNOT_TAKE_SUPERVISION = 'CANNOT_TAKE_SUPERVISION',
    CANNOT_TAKE_TASK = 'CANNOT_TAKE_TASK',
    CANNOT_UPDATE_ABSENCE = 'CANNOT_UPDATE_ABSENCE',
    CANNOT_UPDATE_ACCOUNT_REQUEST = 'CANNOT_UPDATE_ACCOUNT_REQUEST',
    CANNOT_UPDATE_ACTIVE_HOLTER_PROCEDURE = 'CANNOT_UPDATE_ACTIVE_HOLTER_PROCEDURE',
    CANNOT_UPDATE_ASK_EMPLOYMENT_TO_FILL_IN_DATA = 'CANNOT_UPDATE_ASK_EMPLOYMENT_TO_FILL_IN_DATA',
    CANNOT_UPDATE_COMPENSATION_PAYOUT = 'CANNOT_UPDATE_COMPENSATION_PAYOUT',
    CANNOT_UPDATE_CONTRACT_SETTING = 'CANNOT_UPDATE_CONTRACT_SETTING',
    CANNOT_UPDATE_DIAGNOSTIC_REPORT_CLOSED = 'CANNOT_UPDATE_DIAGNOSTIC_REPORT_CLOSED',
    CANNOT_UPDATE_DIAGNOSTIC_REPORT_DRAFT_OR_OPEN = 'CANNOT_UPDATE_DIAGNOSTIC_REPORT_DRAFT_OR_OPEN',
    CANNOT_UPDATE_DIAGNOSTIC_REPORT_PERFORMER = 'CANNOT_UPDATE_DIAGNOSTIC_REPORT_PERFORMER',
    CANNOT_UPDATE_DRAFT_DIAGNOSTIC_REPORT = 'CANNOT_UPDATE_DRAFT_DIAGNOSTIC_REPORT',
    CANNOT_UPDATE_DRAFT_PROCEDURE = 'CANNOT_UPDATE_DRAFT_PROCEDURE',
    CANNOT_UPDATE_DRAFT_REQUEST = 'CANNOT_UPDATE_DRAFT_REQUEST',
    CANNOT_UPDATE_EMPLOYMENT_ACTIVE_STATUS = 'CANNOT_UPDATE_EMPLOYMENT_ACTIVE_STATUS',
    CANNOT_UPDATE_EMPLOYMENT_ASSETS = 'CANNOT_UPDATE_EMPLOYMENT_ASSETS',
    CANNOT_UPDATE_EMPLOYMENT_CONTACT_DETAILS = 'CANNOT_UPDATE_EMPLOYMENT_CONTACT_DETAILS',
    CANNOT_UPDATE_EMPLOYMENT_GENERAL_SETTINGS = 'CANNOT_UPDATE_EMPLOYMENT_GENERAL_SETTINGS',
    CANNOT_UPDATE_EMPLOYMENT_PAYMENT_DETAILS = 'CANNOT_UPDATE_EMPLOYMENT_PAYMENT_DETAILS',
    CANNOT_UPDATE_EMPLOYMENT_REGISTRATION_CODES = 'CANNOT_UPDATE_EMPLOYMENT_REGISTRATION_CODES',
    CANNOT_UPDATE_ORGANIZATION_CONTACT_DETAILS = 'CANNOT_UPDATE_ORGANIZATION_CONTACT_DETAILS',
    CANNOT_UPDATE_ORGANIZATION_GENERAL_SETTINGS = 'CANNOT_UPDATE_ORGANIZATION_GENERAL_SETTINGS',
    CANNOT_UPDATE_ORGANIZATION_KSYOS_ACCOUNT = 'CANNOT_UPDATE_ORGANIZATION_KSYOS_ACCOUNT',
    CANNOT_UPDATE_ORGANIZATION_PATIENT_COUNT = 'CANNOT_UPDATE_ORGANIZATION_PATIENT_COUNT',
    CANNOT_UPDATE_ORGANIZATION_SERVICE_NOTIFICATION_SETTINGS = 'CANNOT_UPDATE_ORGANIZATION_SERVICE_NOTIFICATION_SETTINGS',
    CANNOT_UPDATE_ORGANIZATION_WAITING_TIMES = 'CANNOT_UPDATE_ORGANIZATION_WAITING_TIMES',
    CANNOT_UPDATE_OTP_METHOD = 'CANNOT_UPDATE_OTP_METHOD',
    CANNOT_UPDATE_OUTPATIENT_CLINIC_TASKS = 'CANNOT_UPDATE_OUTPATIENT_CLINIC_TASKS',
    CANNOT_UPDATE_PATIENT_CARE_PROVIDER = 'CANNOT_UPDATE_PATIENT_CARE_PROVIDER',
    CANNOT_UPDATE_PATIENT_INVOICE_SERVICE_PRICE = 'CANNOT_UPDATE_PATIENT_INVOICE_SERVICE_PRICE',
    CANNOT_UPDATE_PAYABLE_SERVICE_ACTIVITY = 'CANNOT_UPDATE_PAYABLE_SERVICE_ACTIVITY',
    CANNOT_UPDATE_PAYOUT_RECORDS = 'CANNOT_UPDATE_PAYOUT_RECORDS',
    CANNOT_UPDATE_PRACTITIONER_ACTIVE_STATE = 'CANNOT_UPDATE_PRACTITIONER_ACTIVE_STATE',
    CANNOT_UPDATE_PRACTITIONER_GENERAL_SETTINGS = 'CANNOT_UPDATE_PRACTITIONER_GENERAL_SETTINGS',
    CANNOT_UPDATE_PRACTITIONER_KSYOS_ACCOUNT = 'CANNOT_UPDATE_PRACTITIONER_KSYOS_ACCOUNT',
    CANNOT_UPDATE_PRACTITIONER_REGISTRATION_CODES = 'CANNOT_UPDATE_PRACTITIONER_REGISTRATION_CODES',
    CANNOT_UPDATE_PROCEDURE_DIAGNOSTIC_REPORT = 'CANNOT_UPDATE_PROCEDURE_DIAGNOSTIC_REPORT',
    CANNOT_UPDATE_PROCEDURE_PERFORMER = 'CANNOT_UPDATE_PROCEDURE_PERFORMER',
    CANNOT_UPDATE_PROCEDURE_REQUEST = 'CANNOT_UPDATE_PROCEDURE_REQUEST',
    CANNOT_UPDATE_PROCEDURE_TO_CANCELLED = 'CANNOT_UPDATE_PROCEDURE_TO_CANCELLED',
    CANNOT_UPDATE_REJECTED_REQUEST_TO_ARCHIVED = 'CANNOT_UPDATE_REJECTED_REQUEST_TO_ARCHIVED',
    CANNOT_UPDATE_REJECTED_REQUEST_TO_RESENT = 'CANNOT_UPDATE_REJECTED_REQUEST_TO_RESENT',
    CANNOT_UPDATE_REQUEST_HIDE_REQUESTED_EXAMINATION_IN_TASKLIST_AND_HOME = 'CANNOT_UPDATE_REQUEST_HIDE_REQUESTED_EXAMINATION_IN_TASKLIST_AND_HOME',
    CANNOT_UPDATE_REQUEST_REQUESTER = 'CANNOT_UPDATE_REQUEST_REQUESTER',
    CANNOT_UPDATE_REQUEST_TO_ABORTED = 'CANNOT_UPDATE_REQUEST_TO_ABORTED',
    CANNOT_UPDATE_REQUEST_TO_ACCEPTED = 'CANNOT_UPDATE_REQUEST_TO_ACCEPTED',
    CANNOT_UPDATE_REQUEST_TO_ACTIVE = 'CANNOT_UPDATE_REQUEST_TO_ACTIVE',
    CANNOT_UPDATE_REQUEST_TO_CANCELLED = 'CANNOT_UPDATE_REQUEST_TO_CANCELLED',
    CANNOT_UPDATE_REQUEST_TO_REJECTED = 'CANNOT_UPDATE_REQUEST_TO_REJECTED',
    CANNOT_UPDATE_SEND_DIAGNOSTIC_REPORT = 'CANNOT_UPDATE_SEND_DIAGNOSTIC_REPORT',
    CANNOT_UPDATE_SEND_PROCEDURE = 'CANNOT_UPDATE_SEND_PROCEDURE',
    CANNOT_UPDATE_SEND_REQUEST = 'CANNOT_UPDATE_SEND_REQUEST',
    CANNOT_UPDATE_SERVICE_CONSUMER = 'CANNOT_UPDATE_SERVICE_CONSUMER',
    CANNOT_UPDATE_SERVICE_CONSUMER_EMAIL_NOTIFICATION_PREFERENCES = 'CANNOT_UPDATE_SERVICE_CONSUMER_EMAIL_NOTIFICATION_PREFERENCES',
    CANNOT_UPDATE_SERVICE_CONSUMER_PERSONAL_SETTINGS = 'CANNOT_UPDATE_SERVICE_CONSUMER_PERSONAL_SETTINGS',
    CANNOT_UPDATE_SERVICE_EMPLOYMENT = 'CANNOT_UPDATE_SERVICE_EMPLOYMENT',
    CANNOT_UPDATE_SERVICE_PROVIDER_EMAIL_NOTIFICATION_PREFERENCES = 'CANNOT_UPDATE_SERVICE_PROVIDER_EMAIL_NOTIFICATION_PREFERENCES',
    CANNOT_UPDATE_SERVICE_PROVIDER_SPECIALIZATIONS = 'CANNOT_UPDATE_SERVICE_PROVIDER_SPECIALIZATIONS',
    CANNOT_UPDATE_SERVICE_SUPERVISOR_EMAIL_NOTIFICATION_PREFERENCES = 'CANNOT_UPDATE_SERVICE_SUPERVISOR_EMAIL_NOTIFICATION_PREFERENCES',
    CANNOT_UPDATE_SUPERVISION = 'CANNOT_UPDATE_SUPERVISION',
    CANNOT_UPDATE_SUPERVISION_PERFORMER = 'CANNOT_UPDATE_SUPERVISION_PERFORMER',
    CANNOT_UPDATE_TASK_PERFORMER = 'CANNOT_UPDATE_TASK_PERFORMER',
    CANNOT_UPDATE_THIRDPARTYSSOIDENTIFIER = 'CANNOT_UPDATE_THIRDPARTYSSOIDENTIFIER',
    CANNOT_UPSERT_ACTIVATION_ASSETS = 'CANNOT_UPSERT_ACTIVATION_ASSETS',
    CANNOT_UPSERT_DIAGNOSTIC_REPORT_ASSETS = 'CANNOT_UPSERT_DIAGNOSTIC_REPORT_ASSETS',
    CANNOT_UPSERT_DIAGNOSTIC_REPORT_DIAGNOSIS = 'CANNOT_UPSERT_DIAGNOSTIC_REPORT_DIAGNOSIS',
    CANNOT_UPSERT_PRACTITIONER_ASSETS = 'CANNOT_UPSERT_PRACTITIONER_ASSETS',
    CANNOT_UPSERT_PROCEDURE_ASSETS = 'CANNOT_UPSERT_PROCEDURE_ASSETS',
    CANNOT_UPSERT_PROCEDURE_MEDICATIONS = 'CANNOT_UPSERT_PROCEDURE_MEDICATIONS',
    CANNOT_UPSERT_PROCESS_ACTIVITY_ALLERGIES = 'CANNOT_UPSERT_PROCESS_ACTIVITY_ALLERGIES',
    CANNOT_UPSERT_PROCESS_ACTIVITY_EPISODES = 'CANNOT_UPSERT_PROCESS_ACTIVITY_EPISODES',
    CANNOT_UPSERT_PROCESS_ACTIVITY_JOURNAL_ENTRY = 'CANNOT_UPSERT_PROCESS_ACTIVITY_JOURNAL_ENTRY',
    CANNOT_UPSERT_PROCESS_ACTIVITY_LAB_RESULTS = 'CANNOT_UPSERT_PROCESS_ACTIVITY_LAB_RESULTS',
    CANNOT_UPSERT_PROCESS_ACTIVITY_MEDICATIONS = 'CANNOT_UPSERT_PROCESS_ACTIVITY_MEDICATIONS',
    CANNOT_UPSERT_REQUEST_ALLERGIES = 'CANNOT_UPSERT_REQUEST_ALLERGIES',
    CANNOT_UPSERT_REQUEST_ASSETS = 'CANNOT_UPSERT_REQUEST_ASSETS',
    CANNOT_UPSERT_REQUEST_DIAGNOSIS = 'CANNOT_UPSERT_REQUEST_DIAGNOSIS',
    CANNOT_UPSERT_REQUEST_EPISODES = 'CANNOT_UPSERT_REQUEST_EPISODES',
    CANNOT_UPSERT_REQUEST_JOURNAL_ENTRY = 'CANNOT_UPSERT_REQUEST_JOURNAL_ENTRY',
    CANNOT_UPSERT_REQUEST_LAB_RESULTS = 'CANNOT_UPSERT_REQUEST_LAB_RESULTS',
    CANNOT_UPSERT_REQUEST_MEDICATIONS = 'CANNOT_UPSERT_REQUEST_MEDICATIONS',
    CANNOT_USE_CHATBOT_SSO = 'CANNOT_USE_CHATBOT_SSO',
    CANNOT_VIEW_OTHER_ORGANIZATIONS_PROFILE = 'CANNOT_VIEW_OTHER_ORGANIZATIONS_PROFILE',
    CANNOT_VIEW_OTHER_PRACTITIONERS_PROFILE = 'CANNOT_VIEW_OTHER_PRACTITIONERS_PROFILE',
    CANNOT_VIEW_OTHER_USERS_EMPLOYMENT_SETTINGS = 'CANNOT_VIEW_OTHER_USERS_EMPLOYMENT_SETTINGS',
    CANNOT_WRITE_GROUP_MEETINGS_FROM_OTHER_ORGANIZATION = 'CANNOT_WRITE_GROUP_MEETINGS_FROM_OTHER_ORGANIZATION',
    CANNOT_WRITE_GROUP_MEETINGS_PATIENTS_WITH_DIFFERENT_TYPE = 'CANNOT_WRITE_GROUP_MEETINGS_PATIENTS_WITH_DIFFERENT_TYPE',
    CANNOT_WRITE_GROUP_SESSIONS = 'CANNOT_WRITE_GROUP_SESSIONS',
    CANNOT_WRITE_MDOS = 'CANNOT_WRITE_MDOS',
    FEATURE_UNAVAILABLE = 'FEATURE_UNAVAILABLE',
    MFA_REQUIRED_LOGIN_NOT_ALLOWED = 'MFA_REQUIRED_LOGIN_NOT_ALLOWED',
    MISSING_ACCOUNT_REQUEST_APPROVER_ID = 'MISSING_ACCOUNT_REQUEST_APPROVER_ID',
    MISSING_ACCOUNT_REQUEST_AUTHORIZATION = 'MISSING_ACCOUNT_REQUEST_AUTHORIZATION',
    MISSING_MANAGER_ROLE_AUTHORIZATION = 'MISSING_MANAGER_ROLE_AUTHORIZATION',
    MISSING_ORGANIZATION_PAYOUT_MANAGER_ROLE = 'MISSING_ORGANIZATION_PAYOUT_MANAGER_ROLE',
    MISSING_OUTPATIENT_CLINIC_TASK_AUTHORIZATION = 'MISSING_OUTPATIENT_CLINIC_TASK_AUTHORIZATION',
    MISSING_TOKEN = 'MISSING_TOKEN',
    NO_EXACT_SESSION = 'NO_EXACT_SESSION',
    NOT_ALLOWED_TO_CHANGE_PERFORMER = 'NOT_ALLOWED_TO_CHANGE_PERFORMER',
    NOT_ALLOWED_TO_CHANGE_PROFESSION = 'NOT_ALLOWED_TO_CHANGE_PROFESSION',
    NOT_ALLOWED_TO_CHANGE_RECIPIENT = 'NOT_ALLOWED_TO_CHANGE_RECIPIENT',
    NOT_ALLOWED_TO_EXPORT = 'NOT_ALLOWED_TO_EXPORT',
    NOT_ALLOWED_TO_FIND_ADMIN_PROCESSES = 'NOT_ALLOWED_TO_FIND_ADMIN_PROCESSES',
    NOT_ALLOWED_TO_FIND_PROCESS_ACTIVITIES = 'NOT_ALLOWED_TO_FIND_PROCESS_ACTIVITIES',
    NOT_ALLOWED_TO_FIND_THIRD_PARTY_MESSAGES = 'NOT_ALLOWED_TO_FIND_THIRD_PARTY_MESSAGES',
    NOT_ALLOWED_TO_GET_HOLTER_CONFIGURATION_DATA_DUE_TO_WRONG_SERVICE = 'NOT_ALLOWED_TO_GET_HOLTER_CONFIGURATION_DATA_DUE_TO_WRONG_SERVICE',
    NOT_ALLOWED_TO_GET_HOLTER_CONFIGURATION_DATA_DUE_TO_WRONG_TOKEN = 'NOT_ALLOWED_TO_GET_HOLTER_CONFIGURATION_DATA_DUE_TO_WRONG_TOKEN',
    NOT_ALLOWED_TO_GET_PATIENT_DATA_DUE_TO_WRONG_TOKEN = 'NOT_ALLOWED_TO_GET_PATIENT_DATA_DUE_TO_WRONG_TOKEN',
    NOT_ALLOWED_TO_GET_UPLOAD_URL = 'NOT_ALLOWED_TO_GET_UPLOAD_URL',
    NOT_ALLOWED_TO_REMOVE_FINANCIAL_RECORDS = 'NOT_ALLOWED_TO_REMOVE_FINANCIAL_RECORDS',
    NOT_ALLOWED_TO_SET_HANDLING_INFO = 'NOT_ALLOWED_TO_SET_HANDLING_INFO',
    ORGANIZATION_NOT_INVOLVED_WITH_PATIENT_AND_EPISODE_CATEGORY = 'ORGANIZATION_NOT_INVOLVED_WITH_PATIENT_AND_EPISODE_CATEGORY',
    TOKEN_HAS_EXPIRED = 'TOKEN_HAS_EXPIRED',
    UNKNOWN_TOKEN = 'UNKNOWN_TOKEN',
}
